<app-chip
  class="filter-chip"
  removable
  [removeLabel]="'Remove filter ' + item().view"
  (removed)="item().delete()">
  {{ item().view }}
</app-chip>
